<template>
    <div class="flex-side">
        <div @click="qqClick" class="customer">
            <img
                src="@/assets/svg/home/customer.svg"
                class="image"
                alt="在线客服"
            />
            <span>在线客服</span>
            <p class="unReaderCount" v-if="unReaderCount > 0"></p>
        </div>
        <el-popover
            placement="left"
            trigger="hover"
            popper-class="customer-wx-flex"
        >
            <template #reference>
                <div class="customer">
                    <img
                        src="@/assets/svg/home/wechart.svg"
                        class="image"
                        alt="微信咨询"
                    />
                    <span>微信咨询</span>
                </div>
            </template>
            <img
                class="customer-tip"
                src="@/assets/images/ProHome/Qrcode.png"
                alt="关注公众号联系客服"
            />
        </el-popover>
        <div @click="goCanSampleApply" class="customer">
            <span class="canSampleApply">{{
                storeShop.haveCanSampleApply > 99
                    ? '99+'
                    : storeShop.haveCanSampleApply
            }}</span>
            <img
                src="@/assets/svg/home/canSampleApply.svg"
                class="image"
                alt="浏览足迹"
            />
            <span>样品清单</span>
        </div>
        <div @click="goHistory" class="customer">
            <img
                src="@/assets/svg/home/history.svg"
                class="image"
                alt="浏览足迹"
            />
            <span>浏览足迹</span>
        </div>
        <div class="customer" v-isLoginClickCheck @click="goComplanints">
            <img
                src="@/assets/svg/home/gift.svg"
                class="image"
                alt="有奖反馈"
            />
            <span>有奖反馈</span>
        </div>
        <div class="customer" @click="goTop">
            <img
                src="@/assets/svg/home/back-top.svg"
                class="image"
                alt="回顶部"
            />
            <span>回顶部</span>
        </div>
    </div>
</template>
<script lang="ts">
import {
    reactive,
    toRefs,
    defineComponent,
    getCurrentInstance,
    onMounted,
    onDeactivated,
} from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/User';
import customerImg from '@/assets/images/Customer/customer.png';
import { useShopStore } from '@/store/Shop';
import qwClientApi from '@/api/PcModule/qwClient';
export default defineComponent({
    name: 'FlexSide',
    components: {},
    setup() {
        const store = useUserStore();
        const storeShop = useShopStore();
        let router = useRouter();
        const data = reactive({
            visible: false,
            unReaderCount: 0,
            timer: null,
        });
        const refData = toRefs(data);
        let { proxy } = getCurrentInstance();
        onMounted(() => {
            window.addEventListener('scroll', handleScroll);
            if (store.userInfo.id) {
                storeShop.getCanSampleApplyAction();
            }
        });
        onDeactivated(() => {
            window.removeEventListener('scroll', handleScroll);
        });
        const handleScroll = () => {
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            proxy.scrollTop = scrollTop;
        };
        const goTop = () => {
            let timer = setInterval(() => {
                let ispeed = Math.floor(-proxy.scrollTop / 10);
                document.documentElement.scrollTop = document.body.scrollTop =
                    proxy.scrollTop + ispeed;
                if (proxy.scrollTop === 0) {
                    clearInterval(timer);
                }
            });
        };
        const goVolume = () => {
            router.push({
                name: 'volume',
            });
        };
        const showCustomer = () => {
            if (store.userInfo.id) {
                const newPage = router.resolve({
                    name: 'customer',
                });
                window.open(newPage.href);
            }
            // window.open('https://work.weixin.qq.com/kfid/kfc94655adeb71b4ea0');
        };
        const goComplanints = () => {
            if (store.userInfo.id) {
                const newPage = router.resolve({
                    name: 'q',
                });
                window.open(newPage.href);
            }
        };
        const qqClick = async () => {
            const newPage = router.resolve({
                name: 'customer',
            });
            // window.open(newPage.href);
            if (store.userInfo.id) {
                let res = await qwClientApi.getContactWay({
                    userId: store.userInfo.id,
                    memberId: 10000,
                });
                window.open(res.message);
                refData.unReaderCount.value = 0;
            } else {
                router.push({
                    name: 'login',
                    query: {
                        callback:
                            location.protocol +
                            '//' +
                            location.host +
                            location.pathname +
                            (location.search !== ''
                                ? '?' + encodeURI(location.search.substring(1))
                                : ''),
                    },
                });
            }
        };

        const goHistory = () => {
            if (store.userInfo.id) {
                router.push({
                    name: 'mineFootprint',
                    query: {
                        title: '我的足迹',
                    },
                });
            } else {
                router.push({
                    name: 'login',
                    query: {
                        callback:
                            location.protocol +
                            '//' +
                            location.host +
                            location.pathname +
                            (location.search !== ''
                                ? '?' + encodeURI(location.search.substring(1))
                                : ''),
                    },
                });
            }
        };
        const goCanSampleApply = () => {
            if (store.userInfo.id) {
                router.push({
                    name: 'canSampleApply',
                });
            } else {
                router.push({
                    name: 'login',
                    query: {
                        callback:
                            location.protocol +
                            '//' +
                            location.host +
                            location.pathname +
                            (location.search !== ''
                                ? '?' + encodeURI(location.search.substring(1))
                                : ''),
                    },
                });
            }
        };
        return {
            ...refData,
            storeShop,
            goTop,
            goVolume,
            showCustomer,
            goComplanints,
            customerImg,
            qqClick,
            goHistory,
            goCanSampleApply,
        };
    },
});
</script>
<style scoped lang="scss">
@keyframes run {
    from {
        background-position: 0 -10px;
    }

    to {
        background-position: 0 -2750px;
    }
}

@-webkit-keyframes run {
    from {
        background-position: 0 -10px;
    }

    to {
        background-position: 0 -2750px;
    }
}

@-webkit-keyframes runHover {
    from {
        background-position: 0 -60px;
    }

    to {
        background-position: 0 -12755px;
    }
}

@keyframes light {
    from {
        box-shadow: 0px 0px 4px $font-color;
    }

    to {
        box-shadow: 0px 0px 16px $font-color;
    }
}

.flex-side {
    position: fixed;
    top: 396px;
    right: 0;
    z-index: 10;
    width: 64px;
    background: #ffffff;
    border-radius: 6px 0px 0px 6px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
    padding: 4px;
    box-sizing: border-box;

    .customer {
        text-align: center;
        cursor: pointer;
        height: 58px;
        box-sizing: border-box;
        margin-bottom: 4px;
        position: relative;

        .image {
            width: 22px;
            height: 22px;
            margin: 7px auto 6px;
        }

        span {
            display: block;
            font-size: 12px;
            line-height: 140%;
            color: #333333;
            // cursor: pointer;
        }

        .unReaderCount {
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: red;
            display: block;
            right: 6px;
            top: 6px;
        }

        .canSampleApply {
            position: absolute;
            top: -2px;
            right: 2px;
            border-radius: 8px;
            width: 22px;
            height: 16px;
            background: #ffc220;
            color: #333;
            font-size: 12px;
            font-weight: 749;
        }
    }

    .customer:nth-of-type(1) {
        height: 56px;
    }

    .customer:nth-of-type(3) {
        height: 56px;
    }

    .customer:last-of-type {
        margin-bottom: 0;
    }

    .customer:hover {
        background: #e5f1fc;
    }

    // .customer:hover .customer-tips {
    //     display: block;
    // }
    // .customer-tips {
    //     display: none;
    //     position: absolute;
    //     left: -152px;
    //     top: -5px;
    //     width: 144px;
    //     height: 58px;
    //     padding: 10px 16px;
    //     box-sizing: border-box;
    //     background: #ffffff;
    //     box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    //     border-radius: 4px;
    //     .tips-top {
    //         .tips-top-img {
    //             width: 16px;
    //             height: 16px;
    //             margin: 0;
    //         }
    //         p {
    //             font-size: 12px;
    //             color: #121214;
    //         }
    //     }
    //     .tips-span {
    //         font-size: 12px;
    //         color: #999999;
    //         margin-top: 6px;
    //         line-height: 140%;
    //     }
    // }
}

.customer-tip {
    width: 91px;
    height: 91px;
}
</style>

<style lang="scss">
.customer-wx-flex {
    padding: 8px 4px 0 !important;
    text-align: center !important;
    width: 110px !important;
    min-width: 110px !important;

    .customer-wx-p {
        color: #333;
        text-align: center;
        font-size: 12px;
        font-family: 思源黑体 CN;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        width: 120px !important;
        min-width: 120px !important;
    }

    .customer-tip {
        width: 91px;
        height: 91px;
    }
}
</style>
